import { useState } from 'react';

import { cn } from '@/lib/utils';

export default function CopyableId({
  value,
  className,
}: {
  value: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 900);
  };
  return (
    <button
      onClick={handleCopy}
      title={value}
      className={cn(
        'font-mono text-[10px] text-muted-foreground/60 transition-colors hover:text-foreground',
        className
      )}
    >
      {copied ? 'Copied' : `[${value}]`}
    </button>
  );
}
